export enum LabelColor {
    GREEN = "#7BC86C",
    YELLOW = "#F5DD29",
    ORANGE = "#FFAF3F",
    RED = "#EF7564",
    PURPLE = "#CD8DE5",
    BLUE = "#5BA4CF",
    CHARCOAL = "#343E51"
}